import { getFeature } from 'Cloud/Application/FeaturesEs6';

// CLOUDWEB-18610
// Доработка флоу восстановления файлов
export const overquotaImgAbTest: 'a' | 'b' | 'c' | undefined = getFeature('ab-overquota-img');
